// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Рішення» (Solutions, ключ `csol`, група `creative`). */
export const solutionsManifest: IModuleManifest = {
  key: 'csol',
  group: 'creative',
  slug: 'solutions',
  prefix: 'SOL',
  name: { en: 'Solutions', uk: 'Рішення' },
  entities: [
    { key: 'csol', slug: 'csol', name: { en: 'Solutions', uk: 'Рішення' }, main: true },
  ],
  loadState: () => import('./state/solutionsSlice').then((m) => m.solutionsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
